var map = {
	"./C-PVC Pipe Fitting": "4319",
	"./C-PVC Pipe Fitting.json": "4319",
	"./Double Lever Mixer": "997d",
	"./Double Lever Mixer.json": "997d",
	"./Drainage Fitting": "a9ec",
	"./Drainage Fitting.json": "a9ec",
	"./Drainer": "ce4a",
	"./Drainer.json": "ce4a",
	"./H- PVC Pipe Fitting": "7ae8",
	"./H- PVC Pipe Fitting.json": "7ae8",
	"./Hose": "3676",
	"./Hose.json": "3676",
	"./Hose_OLd": "546e",
	"./Hose_OLd.json": "546e",
	"./PP-R Fitting": "2565",
	"./PP-R Fitting.json": "2565",
	"./Shattaf Set": "8b37",
	"./Shattaf Set.json": "8b37",
	"./Shower Set": "edb8",
	"./Shower Set.json": "edb8",
	"./Single Function Water Tap": "0800",
	"./Single Function Water Tap.json": "0800",
	"./Single Lever Mixer": "8ea7",
	"./Single Lever Mixer.json": "8ea7",
	"./Valve": "8d8d",
	"./Valve.json": "8d8d",
	"./Water Filter": "bc10",
	"./Water Filter.json": "bc10",
	"./Water Pump": "1442",
	"./Water Pump.json": "1442"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c87";